import { __ } from "src/libs/utilities"
import { InlineButton } from "."
import { IPlayListProps } from "./PlayList" 
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface IPlayListTileProps {
   columnsCount?: number
}
const PlayListTile = (props: IPlayListProps): JSX.Element => { 
    const w = props.containerWidth > WINDOW_WIDTH.MOBILE 
        ? 
        props.containerWidth / (props.columnsCount || 2) 
        : 
        props.containerWidth
    const h = w / (props.btnWidth || 640) * (props.btnHeight || 360) 

    return <div className='pe-play-list-tile-container'>
    {
        props.items.map((item,i) =>  <InlineButton
            key={i}
            src={item?.src}
            label={item.label || __("Empty playlist")}
            description={item.content }
            image={item?.image || props.image?.toString() || ""}
            padding={ props.padding || 0 }
            intent={ props.intent }
            minimal={ props.minimal } 
            btnWidth={  w - ( props.padding || 0 ) * 2 }
            btnHeight={ h - ( props.padding || 0 ) * 2 }
            fill={ props.fill }
            isModal={ false } 
            isAutoMode={ false }
            isPlayButton={ 
                typeof props.isPlayButton === "undefined" 
                    ? 
                    true 
                    : 
                    props.isPlayButton  && !!props.items.length 
            }
            isPlayed={ false } 
        />)
    }   
    </div>
}
export default PlayListTile